import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class QrCode extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { qrCode, text1, text2 },
        } = this.props;

        return (
            <div className={styles.qr_box}>
                <img src={qrCode} alt="" />
                <div className={styles.text_box}>
                    <p>{text1}</p>
                    <p>{text2}</p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(QrCode);
